import { render, staticRenderFns } from "./Marriage.vue?vue&type=template&id=e92cccbe&scoped=true&"
import script from "./Marriage.vue?vue&type=script&lang=js&"
export * from "./Marriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92cccbe",
  null
  
)

export default component.exports